/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOptionRespVo
 */
export interface GetOptionRespVo {
    /**
     * 选项编号
     * @type {number}
     * @memberof GetOptionRespVo
     */
    code?: number;
    /**
     * 选项名称
     * @type {string}
     * @memberof GetOptionRespVo
     */
    name?: string;
}

/**
 * Check if a given object implements the GetOptionRespVo interface.
 */
export function instanceOfGetOptionRespVo(value: object): value is GetOptionRespVo {
    return true;
}

export function GetOptionRespVoFromJSON(json: any): GetOptionRespVo {
    return GetOptionRespVoFromJSONTyped(json, false);
}

export function GetOptionRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOptionRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function GetOptionRespVoToJSON(json: any): GetOptionRespVo {
    return GetOptionRespVoToJSONTyped(json, false);
}

export function GetOptionRespVoToJSONTyped(value?: GetOptionRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

